import React, { Component } from 'react';
import { getFanstepIcon, isEmpty } from '../../../../Common/Common';

export default class Fan_Step extends Component {
	constructor(props) {
		super(props);

		let fanstep = 'L';
		let steps = 3;

		if (this.props.group_id == null) {
			if (!isEmpty(this.props.point_info)) {
				fanstep = this.props.point_info.fanstep;
				steps = this.props.point_info.fanstep_cap.S != null ? this.props.point_info.fanstep_cap.S : 3;
			}
		} else {
			// Retrieve the highest number of steps by comparing each AC in group_info
			steps = 0;
			for (let mp of this.props.group_info.mp) {
				let point_info = window.app.state.point_list[mp];
				// Do not check the target if it does not exist in the point list anymore
				if (point_info != null) {
					if (point_info.type == 'Ac') {
						if (point_info.fanstep_cap.S > steps) steps = point_info.fanstep_cap.S;
					}
				}
			}
			this.group_steps = steps;
		}

		let icon = getFanstepIcon(steps, fanstep)

		this.state = {
			fanstep: fanstep,
			icon: icon
		}
	}

	handleChangeFanstep = () => {
		let step = this.state.fanstep;
		let steps = 3;

		if (this.props.group_id == null) {
			if (!isEmpty(this.props.point_info)) {
				steps = this.props.point_info.fanstep_cap.S != null ? this.props.point_info.fanstep_cap.S : 3;
			}
		} else {
			steps = this.group_steps;
		}

		if (step == 'L') {
			if (steps == 2) step = 'H';
			else if (steps == 3) step = 'M';
			else step = 'LM';
		} else if (step == 'LM') {
			step = 'M';
		} else if (step == 'M') {
			if (steps == 3) step = 'H';
			else step = 'MH';
		} else if (step == 'MH') {
			step = 'H';
		} else if (step == 'H') {
			step = 'A';
		} else if (step == 'A') {
			if (this.props.group_id == null) {
				if (this.props.point_info.fanstep_cap.Q) {
					step = 'Q';
				} else {
					step = 'L';
				}
			} else {
				step = 'L';
			}
		} else if (step == 'Q') {
			step = 'L';
		}

		this.setState({
			fanstep: step,
			icon: getFanstepIcon(steps, step)
		})

		this.props.handleChangeFanstep(step);
	}

	render() {
		return (
			<div id='fanstep' style={this.props.style} onClick={this.handleChangeFanstep}>

				<div>
					<img src={this.state.icon} style={{ width: 40 }} />
				</div>

				<div>
					<span> {this.props.receiver.getString('fanstep')} </span>
				</div>
			</div>
		)
	}
}